import React, { Component } from 'react'
import {ProductConsumer} from '../context';
import {Link} from 'react-router-dom';
import {ButtonContainer} from './ButtonTwo';
import Product from './Product';

export default class Details extends Component {
    render() {
        return (
           <ProductConsumer>
                {(value)=>{
                 const {id, 
                    company, 
                    img, 
                    info ,
                     price, 
                     title, 
                     inCart} = value.detailProduct;
                    return (
                        <div className="container py-5">
                        {/* title  */ }
                            <div className="row">
                            <div className="col-10 mx-auto text-center text-slanted text-black my-5">
                            <h1>Product Details</h1>
                            <hr/>

                            </div>
                         </div>
                         <div className="row">
                            <div className="col-10 mx-auto col-md-6 
                            my-3">
                            <img src={img} className="img-fluid" alt="product"/>
                            </div>
                            <div className="col-10 mx-auto col-md-6 
                            my-3 text-capitalize">
                            <h3>{title}</h3>
                            <h3 className="mt-3 mb-2"> {company}</h3>
                            <h4 className = "text-blue">
                                <strong>
                                    <span> $ </span>
                                    {price}
                                </strong>
                            </h4>
                            <p className="text-capitalize font-weight-bold mt-3 mb-0">
                            Info: 
                            </p>
                            <p className="text-muted lead">{info}</p>
                            <div>
                                <Link to='/'>
                                <ButtonContainer> Return to Products</ButtonContainer>
                                
                                </Link>
                                <ButtonContainer disabled={inCart?true:false}
                                onClick={()=>{
                                    value.addToCart(id);
                                    value.openModal(id);
                                }}> {inCart?"inCart" : "add to cart"}</ButtonContainer>
                                </div>
                             </div>
                            </div>
                        </div>
                    );

                }}
            
           </ProductConsumer>
        )
    }
}
